"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var React = require('react');

var PropTypes = require('prop-types');

var _ = require('lodash');

var compose = require('../../hoc/compose');

var template = require('./horizontalTabs.jsx');

var displayNames = require('../displayNames');

var _require = require('../radioButtonsHelpers'),
    generateChildrenFromOptions = _require.generateChildrenFromOptions;

var ARROW_WIDTH = 30;
var BORDER_WIDTH = 1;
var DEFAULT_CONTAINER_WIDTH = 480;
var SIDES = {
  LEFT: 'left',
  RIGHT: 'right'
};

var HorizontalTabs = /*#__PURE__*/function (_React$Component) {
  _inherits(HorizontalTabs, _React$Component);

  var _super = _createSuper(HorizontalTabs);

  function HorizontalTabs(props) {
    var _this;

    _classCallCheck(this, HorizontalTabs);

    _this = _super.call(this, props);

    _this.getRootCssClasses = function () {
      var classList = ['control-horizontal-tabs'];

      if (_this.props.arrowedBox) {
        classList.push('arrowed-box');
      } else {
        classList.push(_this.props.arrowed ? 'arrowed' : 'tabbed');
      }

      return classList.join(' ');
    };

    _this.groupId = _.uniqueId('radioGroup');

    _this.generateChildren = function () {
      return _this.props.options ? generateChildrenFromOptions(_this.props) : _.castArray(_this.props.children);
    };

    _this.state = {
      tabsContainerWidth: 0,
      tabWidth: 110,
      tabsListOffset: 0,
      showTabsFrom: 0,
      firstDisplayedTabIndex: 0,
      lastDisplayedTabIndex: 0,
      maxPossibleVisibleTabs: 0,
      showLeftArrow: false,
      showRightArrow: false,
      tabsToSkipOnClick: 0,
      shouldRefocusOnSelectedTab: true
    };
    _this.onTabChange = _.debounce(_this.onTabChange, 50);

    _this.setTabsContainerRef = function (element) {
      _this.tabsContainerRef = element;
    };

    return _this;
  }

  _createClass(HorizontalTabs, [{
    key: "getDefaultTabsToSkip",
    value: function getDefaultTabsToSkip(maxPossibleVisibleTabs) {
      var tabsToSkipOnClick = this.props.tabsToSkipOnClick;
      return tabsToSkipOnClick ? tabsToSkipOnClick : Math.floor(maxPossibleVisibleTabs / 2);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.maxVisibleTabs) {
        this.onLayoutChange();

        this.layoutEventListener = function () {
          return _this2.onLayoutChange();
        };

        window.addEventListener('resize', this.layoutEventListener);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.maxVisibleTabs && (prevProps.options.length !== this.props.options.length || prevProps.maxVisibleTabs !== this.props.maxVisibleTabs)) {
        this.onLayoutChange();
      } else if (prevProps.value !== this.props.value || this.getSlidingProps().shouldSlide && prevState.shouldRefocusOnSelectedTab && this.state.shouldRefocusOnSelectedTab) {
        this.onTabChange();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.maxVisibleTabs) {
        window.removeEventListener('resize', this.layoutEventListener);
      }
    }
  }, {
    key: "onLayoutChange",
    value: function onLayoutChange() {
      var maxVisibleTabs = this.props.maxVisibleTabs;
      var options = this.props.options;
      var spaceForArrow = options.length > maxVisibleTabs ? ARROW_WIDTH : 0;
      var maxPossibleVisibleTabs = Math.min(maxVisibleTabs, options.length);
      var tabsContainerWidth = this.getTabsContainerWidth(maxPossibleVisibleTabs);
      var spaceForGutter = maxPossibleVisibleTabs * BORDER_WIDTH;
      var tabWidth = (tabsContainerWidth - spaceForArrow - spaceForGutter) / maxPossibleVisibleTabs;
      var newState = {
        maxPossibleVisibleTabs: maxPossibleVisibleTabs,
        tabsContainerWidth: tabsContainerWidth,
        tabWidth: tabWidth,
        tabsListOffset: 0,
        showTabsFrom: 0,
        firstDisplayedTabIndex: 0,
        lastDisplayedTabIndex: maxPossibleVisibleTabs - 1,
        showRightArrow: this.shouldShowRightArrow(0, tabsContainerWidth, tabWidth),
        showLeftArrow: false,
        tabsToSkipOnClick: this.getDefaultTabsToSkip(maxPossibleVisibleTabs),
        shouldRefocusOnSelectedTab: true
      };
      this.setState(newState);
    }
  }, {
    key: "getTabsContainerWidth",
    value: function getTabsContainerWidth(maxPossibleVisibleTabs) {
      var tabWidth = this.state.tabWidth;
      return _(this.tabsContainerRef) // eslint-disable-line
      .chain().invoke('getBoundingClientRect').get('width', maxPossibleVisibleTabs * tabWidth + this.ARROW_WIDTH).value() || DEFAULT_CONTAINER_WIDTH;
    }
  }, {
    key: "slide",
    value: function slide(side, options) {
      var showLeftArrow = false;
      var showRightArrow = false;
      var nextOffset = 0;

      if (side === SIDES.LEFT) {
        nextOffset = this.getOffsetAfterSkippingLeft(options && options.tabsToSkip);
        showLeftArrow = nextOffset < 0;
        showRightArrow = true;
      } else if (side === SIDES.RIGHT) {
        nextOffset = this.getOffsetAfterSkippingRight(options && options.tabsToSkip);
        showLeftArrow = true;
        showRightArrow = this.shouldShowRightArrow(nextOffset, this.state.tabsContainerWidth, this.state.tabWidth);
      }

      var _this$getFirstAndLast = this.getFirstAndLastTabsIndices(nextOffset),
          firstDisplayedTabIndex = _this$getFirstAndLast.firstDisplayedTabIndex,
          lastDisplayedTabIndex = _this$getFirstAndLast.lastDisplayedTabIndex;

      var newState = {
        tabsListOffset: nextOffset,
        showLeftArrow: showLeftArrow,
        showRightArrow: showRightArrow,
        firstDisplayedTabIndex: firstDisplayedTabIndex,
        lastDisplayedTabIndex: lastDisplayedTabIndex,
        shouldRefocusOnSelectedTab: options ? Boolean(options.shouldRefocusOnSelectedTab) : true
      };
      this.setState(newState);
    }
  }, {
    key: "getOffsetAfterSkippingLeft",
    value: function getOffsetAfterSkippingLeft(tabsToSkip) {
      var _this$state = this.state,
          tabsListOffset = _this$state.tabsListOffset,
          tabWidth = _this$state.tabWidth,
          tabsToSkipOnClick = _this$state.tabsToSkipOnClick;
      var addedTabsOffset = (tabsToSkip || tabsToSkipOnClick) * (tabWidth + BORDER_WIDTH);
      var offset = tabsListOffset + addedTabsOffset;
      return Math.min(offset, 0);
    }
  }, {
    key: "getFirstAndLastTabsIndices",
    value: function getFirstAndLastTabsIndices(nextOffset) {
      var _this$state2 = this.state,
          firstDisplayedTabIndex = _this$state2.firstDisplayedTabIndex,
          lastDisplayedTabIndex = _this$state2.lastDisplayedTabIndex;
      var skippingAmount = this.getSkippingAmount(nextOffset);
      return {
        firstDisplayedTabIndex: firstDisplayedTabIndex + skippingAmount,
        lastDisplayedTabIndex: lastDisplayedTabIndex + skippingAmount
      };
    }
  }, {
    key: "getSkippingAmount",
    value: function getSkippingAmount(nextOffset) {
      var _this$state3 = this.state,
          tabsListOffset = _this$state3.tabsListOffset,
          tabWidth = _this$state3.tabWidth;
      var totalTabWidth = tabWidth + BORDER_WIDTH;
      var offsetDiff = nextOffset - tabsListOffset;
      var ratio = offsetDiff / totalTabWidth;
      return -Math.sign(ratio) * Math.round(Math.max(Math.abs(ratio), 1));
    }
  }, {
    key: "getOffsetAfterSkippingRight",
    value: function getOffsetAfterSkippingRight(tabsToSkip) {
      var options = this.props.options;
      var _this$state4 = this.state,
          tabsListOffset = _this$state4.tabsListOffset,
          tabWidth = _this$state4.tabWidth,
          maxPossibleVisibleTabs = _this$state4.maxPossibleVisibleTabs,
          tabsToSkipOnClick = _this$state4.tabsToSkipOnClick;
      var maxTabsToBeSkipped = options.length - maxPossibleVisibleTabs;
      var totalTabWidth = tabWidth + BORDER_WIDTH;
      var maxOffset = ARROW_WIDTH - maxTabsToBeSkipped * totalTabWidth;
      var addedTabsOffset = (tabsToSkip || tabsToSkipOnClick) * (tabWidth + BORDER_WIDTH);
      var offset = tabsListOffset - addedTabsOffset;
      return Math.max(maxOffset, offset);
    }
  }, {
    key: "shouldShowRightArrow",
    value: function shouldShowRightArrow(newOffset, tabsContainerWidth, tabWidth) {
      var options = this.props.options;
      var totalTabsWidth = options.length * tabWidth;
      return totalTabsWidth > tabsContainerWidth - newOffset;
    }
  }, {
    key: "getSlidingProps",
    value: function getSlidingProps() {
      var side;

      var selectedIndex = _.findIndex(this.props.options, ['value', this.props.value]);

      var _this$state5 = this.state,
          firstDisplayedTabIndex = _this$state5.firstDisplayedTabIndex,
          lastDisplayedTabIndex = _this$state5.lastDisplayedTabIndex,
          showLeftArrow = _this$state5.showLeftArrow,
          showRightArrow = _this$state5.showRightArrow;

      if (selectedIndex <= firstDisplayedTabIndex && showLeftArrow) {
        side = SIDES.LEFT;
      } else if (selectedIndex >= lastDisplayedTabIndex && showRightArrow) {
        side = SIDES.RIGHT;
      }

      return {
        side: side,
        shouldSlide: Boolean(side),
        selectedIndex: selectedIndex
      };
    }
  }, {
    key: "onTabChange",
    value: function onTabChange() {
      var slideTo = this.getSlidingProps();

      if (slideTo.shouldSlide) {
        this.slide(slideTo.side, {
          selectedIndex: slideTo.selectedIndex
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return template.call(this);
    }
  }]);

  return HorizontalTabs;
}(React.Component);

var validatePropRange = function validatePropRange(props, propName, component) {
  var prop = props[propName];

  if (prop && (!_.isNumber(prop) || prop < 1)) {
    return new RangeError("Invalid prop ".concat(propName, " supplied to ").concat(component, ". Prop value must be a number greater than 0"));
  }
};

HorizontalTabs.displayName = displayNames.HORIZONTAL_TABS;
HorizontalTabs.propTypes = {
  /** selected tab*/
  value: PropTypes.string.isRequired,

  /** a callback called with the new selected tab on tab click */
  onChange: PropTypes.func.isRequired,

  /** list of all tabs */
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })),

  /** arrowed tabs */
  arrowed: PropTypes.bool,

  /** arrowed box to cover selected tab (hides tabs value and places indexes) */
  arrowedBox: PropTypes.bool,
  tabPredicate: PropTypes.func,

  /** maximum tabs to show */
  maxVisibleTabs: validatePropRange,

  /** number of tabs to skip on click last visible tab */
  tabsToSkipOnClick: validatePropRange
};
HorizontalTabs.defaultProps = {
  arrowed: false,
  arrowedBox: false,
  tabPredicate: function tabPredicate(item) {
    return _.has(item, 'props.value');
  }
};
module.exports = compose(HorizontalTabs);